import React, {useState} from 'react';
import {FiChevronDown} from 'react-icons/fi';

type AccordionProps = {
    children: any,
    title: string,
    active?: boolean
    id?: string
}

const Accordion = (props: AccordionProps) => {

    const {children, title, active , id } = props;

    const [open, setOpen] = useState(active || false);
    const handleOpen = () => setOpen((prev) => !prev);

    return (
        <div className='accordian'>
            <div
                id={id ||`accordian__${title}`}
                className={`accordian__title ${open ? 'open' : 'closed'}`}
                onClick={handleOpen}
            >
                {title}
                <FiChevronDown size={20}/>
            </div>
            {open && (
                <div className={`accordian__content ${open ? 'open' : 'closed'}`}>
                    {children}
                </div>
            )}
        </div>
    );
}

export default Accordion;